/* globals FWP */

// import('../../components/pagination.js');

const filterTitles = document.querySelectorAll('.filter-title');
filterTitles.forEach((filterTitle) => {
	filterTitle.addEventListener('click', (elem) => {
		console.log(elem);

		elem.target.parentNode.classList.toggle('open');
	});
});
